class Template
{
	HeaderScroll()
	{
		const header = $('header#mainHeader .headerContent');
		
		function defineHeaderStatus(pos)
		{
			if(pos >= 34)
				header.css({'position':'fixed', 'top':0});
			else
				header.css({'position':'absolute', 'top':34});
		}
		
		defineHeaderStatus(document.documentElement.scrollTop);

		$(window).scroll(function (event)
		{
			defineHeaderStatus($(window).scrollTop());
		});

		$(window).resize(function()
    	{
			defineHeaderStatus(document.documentElement.scrollTop);

			$(window).scroll(function (event)
			{
				defineHeaderStatus($(window).scrollTop());
			});
		});
	}

	MenuMobile(status = false)
	{
		if($(window).width() <= 1024)
		{
			const mainMenu = $('header#mainHeader nav #mainMenu');
			const openMenu = $('header#mainHeader nav .actionMenu button.open');
			const closeMenu = $('header#mainHeader nav .actionMenu button.close');
					
			function SubMenuMobileClose()
			{
				const hasChildren = $('header#mainHeader nav #mainMenu ul.menu-principal > li.menu-item-has-children');

				hasChildren.removeClass('opened');
			}

			function OpenMenu(obj)
			{
				$('body').css({'overflow':'hidden'});
				$('#CBarraAcessibilidade ul.acessList #wrapContraste').css({'display':'none'});
				
				obj.removeClass('activated');
				closeMenu.addClass('activated');
				mainMenu.addClass('opened');
			}

			function CloseMenu(obj)
			{
				$('body').css({'overflow':'auto'});
				$('#CBarraAcessibilidade ul.acessList #wrapContraste').css({'display':'inline-block'});
				
				obj.removeClass('activated');
				openMenu.addClass('activated');
				mainMenu.removeClass('opened');

				SubMenuMobileClose()
			}

			openMenu.click(function()
			{
				OpenMenu($(this));
			});

			closeMenu.click(function()
			{
				CloseMenu($(this));
			});

			if(status && status == 'resize')
			{
				CloseMenu(closeMenu);
			}
		}
	}

	SubMenuMobileOpen()
	{
		if($(window).width() <= 1024)
		{
			const hasChildren = $('header#mainHeader nav #mainMenu ul.menu-principal > li.menu-item-has-children');

			hasChildren.each(function()
			{
				let self = $(this);
				let link = self.find('> a');

				link.click(function(e)
				{
					e.preventDefault();

					self.toggleClass('opened');
				});
			});
		}
	}

	ScrollTo()
	{
		function ScrollToElement(href)
		{
			let hash = '#'+href.split('#/')[1];
			let altura = $(hash).offset().top - 100;

			window.location = href;

			$('.scrollTo').removeClass('current-page-item');
			$(this).addClass('current-page-item');

			if(altura)
			{
				window.scroll({
					top: altura,
					behavior: 'smooth'
				});
			}
		}
		
		$('.scrollTo').each(function()
		{
			$(this).click(function(e)
			{
				e.preventDefault();

				ScrollToElement($(this).attr('href'));
			});
		});

		let HASH = window.location.hash;

		if(HASH)
		{
			ScrollToElement(HASH);
		}

	}

	PopBusca()
	{
		const popUp = $('#CCBuscaPopUp');
		const popUpContent = popUp.find('.wrapSearchContent');  
		const openBusca = $('header#mainHeader .btn.busca');
		const closeBusca = $('#CCBuscaPopUp button.close');

		openBusca.click(function()
		{
			$('body').css({'overflow':'hidden'});

			popUp.css({'display':'block'}).stop().animate({opacity:1},300,function()
			{
				popUpContent.stop().animate({opacity:1},300);
			})
		});

		closeBusca.click(function()
		{
			popUpContent.stop().animate({opacity:0},300,function()
			{
				popUp.stop().animate({opacity:0},300,function()
				{
					$(this).css({'display':'none'});

					$('body').css({'overflow':'auto'});
				});
			});
		});
	}

	ConactForm()
	{
		/* Validation Events for changing response CSS classes */
		document.addEventListener( 'wpcf7invalid', function( event ) {
			$('.wpcf7-response-output').addClass('alert alert-danger');
		}, false );
		document.addEventListener( 'wpcf7spam', function( event ) {
			$('.wpcf7-response-output').addClass('alert alert-warning');
		}, false );
		document.addEventListener( 'wpcf7mailfailed', function( event ) {
			$('.wpcf7-response-output').addClass('alert alert-warning');
		}, false );
		document.addEventListener( 'wpcf7mailsent', function( event ) {
			$('.wpcf7-response-output').addClass('alert alert-success');
		}, false );

		$('input.phone').mask("(00) 00000-0009", {clearIfNotMatch: true, placeholder: "(__) _____-____"});
	}

	ZoomMidiaUploaded()
	{
		if($('.CCdefaultHTML').length > 0)
		{
			$('.CCdefaultHTML a[rel="fancybox"]').each(function()
			{
				$(this).attr('data-fancybox','fancybox');
			});
		}
	}

	DownloadPesquisa()
	{
		const buttonDonwload 			= $('.CCHtmlPublicacao .interacoes button.btnDownloadPublicacao');
		// const buttonLerOnline 			= $('.CCHtmlPublicacao .interacoes button.btnPulicacaoOnline');

		if(buttonDonwload.length > 0)
		{
			buttonDonwload.click(function(e)
			{
				const urlSurvey 	= buttonDonwload.data('survey');
				const urlDownload 	= buttonDonwload.data('download');

				const partsName		= urlDownload.split('/');
				const pdfName 		= partsName[partsName.length - 1];

				var link = document.createElement('a');
				link.href = urlDownload;
				link.download = pdfName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);

				window.open(urlSurvey, '_blank');

				return false;
			})
		}
	}

	init()
	{
		const self = this;

		if (navigator.userAgent.indexOf("Firefox") == -1)
        {
			self.HeaderScroll();
		}

		self.ScrollTo();
		self.PopBusca();
		self.MenuMobile();
		self.SubMenuMobileOpen();
		self.ConactForm();
		self.ZoomMidiaUploaded();
		self.DownloadPesquisa();
		
		$(window).resize(function()
		{
			if (navigator.userAgent.indexOf("Firefox") == -1)
			{
				self.HeaderScroll();
			}
			
			self.MenuMobile();
		});
	}
}

export default Template;